/*
 *   File : video-detail.js
 *   Author : https://evoqins.com
 *   Description : Video detail modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';

// style 
import styles from "../../Style/Component/modal.module.scss";

//custom components
import { Icon } from '../Icon';
import { CustomRadio, CustomTextInput } from '../FormElements';
import { PrimaryButton } from '../Buttons';

const TYPES = [
    {
        id: 1,
        label: "Text"
    },
    {
        id: 2,
        label: "Upload"
    },
    {
        id: 3,
        label: "Links"
    },
];

const ManageCategoryModal = (props) => {

    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState("");

    const [selectedType, setSelectedType] = useState(1);

    const [selectedField, setSelectedField] = useState(1);

    useEffect(() => {
        if (props.editData) {

            setTitle(props.editData.title ?? "");
            setSelectedType(props.editData.category_type ?? 1);
            setSelectedField(props.editData.category_upload_type ?? 1)
        }
    }, [props.editData]);

    useEffect(() => {
        setTitleError("");
    }, [title]);

    // handle close Modal 
    const _handleCloseModal = () => {
        var button = document.getElementById("manage-category-modal-close");
        button.click();

        props.handleClose();
    };

    const _getData = () => {
        if (selectedType === 1) {
            return [{ title: title, category_name: "", description: "", category_type: selectedType }];
        } else if (selectedType === 2) {
            return selectedField === 1 ? [{ title: title, category_name: "", description: "", file_url: null, category_type: selectedType, category_upload_type: selectedField }] : [{ file_url: null, title: title, enable_download: true, category_type: selectedType, category_upload_type: selectedField }];
        } else {
            return [{ title: title, category_name: "", redirection_link: "", category_type: selectedType }];
        }
    };
    const _handleAdd = () => {

        if (title.trim().length === 0) {
            setTitleError("Please provide title");
        } else {

            let data = _getData()

            _handleCloseModal();
            props.handleSuccess(data);
        }
    };


    return (
        <div className="modal fade" id="manage-category-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="videoDetailModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content e-border-radius-12 w-480px mx-auto overflow-hidden">
                    <img src={require("../../Assets/Image/CountryAdmin/close-icon.svg").default}
                        id='manage-category-modal-close'
                        className='d-none'
                        alt='close'
                        data-bs-dismiss="modal" />

                    <div className="modal-header px-4 pt-3 pb-1 border-0">
                        <h4 className="mb-0 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px">
                            {props.title}
                        </h4>
                        <Icon icon="close-icon"
                            className='cursor-pointer'
                            size="24px"
                            onPress={_handleCloseModal} />
                    </div>

                    <div className={`${styles.e_modal_body_wrapper} pt-1 modal-body px-4 overflow-auto pb-5 e-modal-body-wrapper`}>
                        <p className='mb-3 e-alt-font-noto-sans e-text-davys-grey e-font-14 e-font-weight-400 line-height-20px'>
                            {props.description}
                        </p>

                        <CustomTextInput label="Title"
                            placeholder="Add title"
                            type="text"
                            require
                            value={title}
                            error={titleError}
                            className="w-100 padding-10px-tb"
                            handleChange={(e) => setTitle(e)} />


                        <CustomRadio label="Category type"
                            required={true}
                            data={TYPES}
                            gap=" gap-3"
                            selected={selectedType}
                            onClick={(id) => setSelectedType(id)} />


                        {selectedType === 2 &&
                            <div className='pt-4'>
                                <CustomRadio label="Field"
                                    required={true}
                                    data={[{ id: 1, label: "Document + Title + Description" }, { id: 2, label: "Document only" }]}
                                    gap=" gap-2"
                                    className="flex-column align-items-start"
                                    selected={selectedField}
                                    onClick={(id) => setSelectedField(id)} />
                            </div>
                        }
                    </div>

                    <div className='modal-footer border-0 px-4 pb-4 pt-2'>
                        <PrimaryButton name={props.isEdit ? "Update" : "Add"}
                            className="e-border-radius-16 w-144px m-0"
                            onPress={_handleAdd} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(ManageCategoryModal);
